import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
var PlDescription = function (_a) {
    var label = _a.label, _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx("p", { className: "text-base ".concat(className), children: label });
};
export default PlDescription;
